import React, { useContext } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { useColorScheme } from "react-native-appearance";
import Icon from "react-native-vector-icons/Ionicons";
import { colors } from "../context/Colors";
import AppContext from "../context";
import GameFooter from "./GameFooter";
import GameDescription from "./GameDescription";

export default function MCQText({ g, current }) {
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const { tour, setTour } = useContext(AppContext);

  const answer = (k) => {
    //Check is it required to give multiple answers
    if (g.propositions.filter((p) => p.flag).length > 1) {
      g.state = "";
      g.propositions[k].checked
        ? (g.propositions[k].checked = false)
        : (g.propositions[k].checked = true);

      g.propositions.some((p) => {
        if (p.checked) {
          g.state = "can-answer";
          return true;
        }
      });
    } else {
      g.propositions.forEach((p) => {
        delete p.checked;
      });
      g.propositions[k].checked = true;
      g.state = "can-answer";
    }
    setTour({ ...tour });
  };

  const checkColor = (a) => {
    if (g.state === "failed" && a.checked) return "#DD4D4D";
    if (g.state === "correct" && a.checked) return "#26C97A";
    if (a.checked) return "#23A7F1";
    return colors[theme].checkbox;
  };

  return (
    <View>
      <GameDescription g={g} current={current} />
      <View style={{ marginTop: 10 }}>
        {g.propositions.map((a, k) => (
          <TouchableOpacity
            key={a.propositionID}
            style={{
              marginTop: 20,
              flexDirection: "row",
              alignItems: "center",
            }}
            onPress={() => answer(k)}
            disabled={g.state === "failed" || g.state === "correct"}
          >
            <View
              style={{
                backgroundColor: checkColor(a),
                width: 24,
                height: 24,
                marginRight: 8,
                borderRadius: 12,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Icon
                name="md-checkmark-sharp"
                size={18}
                color="#FFF"
                style={{ opacity: a.checked ? 1 : 0 }}
              />
            </View>
            <Text
              style={{
                fontSize: 16,
                opacity: 0.7,
                color: colors[theme].text,
                flexWrap: "wrap",
                flex: 1,
              }}
            >
              {a.text}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
      {/* <GameFooter g={g} /> */}
    </View>
  );
}
